import React, { useEffect, useState } from "react";
import Logo from "../assets/img/logo.svg";
import Menu from "../assets/img/menu.svg";

import Movie from "../assets/img/movie.svg";
import { Link } from "react-router-dom";
import { Pagination, Tab, Tabs } from "react-bootstrap";
// import VisitRequest from "../Component/VisitRequest";
import Notid from "../assets/img/notification.svg";
import Search from "../assets/img/search-icon.svg";
import Star from "../assets/img/student-profile.svg";
import { GetFunction, handleimageUrl } from "../utils/ApiFunctions";
import { useLocalization } from "../Component/Localization/Localization";

import { AllUrls } from "../utils/UrlSearch";
import moment from "moment";
function Header({ setVisible, visible }) {
  const { t } = useLocalization();
  const [NotifyAuthority, setNotifyAuthority] = useState(false);

  const [toggle, setToggle] = useState(false);

  const [addclass, setAddClass] = useState(false);
  const [type, setType] = useState("school");
  const [notilist, setNotificationList] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const handleClass = () => {
    setAddClass((pre) => !pre);
  };
  useEffect(() => {
    if (addclass) {
      document.body.classList.add("toggle-sidebar");
    } else {
      document.body.classList.remove("toggle-sidebar");
    }

    // Clean up by removing the class when the component unmounts
    return () => {
      document.body.classList.remove("toggle-sidebar");
    };
  }, [addclass]);

  const getNotification = async () => {
    const res = await GetFunction(
      `/notification/list?page=${page}&limit=${limit}&type=${type}`
    );
    if (res.status == 200) {
      setNotificationList(res?.data?.data);
      setTotalPages(res?.data?.pagination?.totalPages);
    }
  };
  useEffect(() => {
    if (visible) {
      getNotification();
    }
  }, [visible, type]);

  const [searchTerm, setSearchTerm] = useState("");
  const [count, setCount] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [totalPages, setTotalPages] = useState([]);

  const handleSearch = (searchTerm) => {
    // if (searchTerm.trim() === "") {
    //   setSearchResult([]);
    //   return;
    // }

    const results = AllUrls.filter((item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setSearchResult(results);
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setSearchTerm(value);
    handleSearch(value);
  };

  useEffect(() => {
    async function fetchData() {
      const response = await GetFunction("/home/teacher-home");
      if (response.status == 200) {
        setCount(response?.data?.data?.notificationCount);
      }
    }

    fetchData();
  }, []);

  const renderPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={page === i ? "active-btn pagination-li" : "pagination-li"}
        >
          <button
            onClick={(e) => {
              // e.stopPropagation();
              handlePageChange(i, e);
            }}
          >
            {i}
          </button>
        </li>
      );
    }
    return pageNumbers;
  };
  const handlePageChange = (val, e) => {
    setPage(val);
  };

  return (
    <div>
      <header
        id="header"
        className="header dashboard-hdr fixed-top d-flex align-items-center"
      >
        <div className="d-flex align-items-center justify-content-between">
          <Link to="/dashboard" className="logo d-flex align-items-center">
            <img src={Logo} alt="" />
          </Link>
          <i className="bi bi-list toggle-sidebar-btn">
            <img
              className="img-fluid"
              src={Menu}
              alt=""
              onClick={() => handleClass()}
            />
          </i>
        </div>

        {/* <div className="search-bar">
          <form className="search-form d-flex align-items-center" action="#">
            <input
              type="text"
              name="query"
              placeholder={t("search")}
              title="Enter search keyword"
              value={searchTerm}
              onChange={handleChange}
            />
            <button type="submit" title="Search">
              <i className="bi bi-search">
                <img className="img-fluid" src={Search} alt="" />
              </i>
            </button>
          </form>

          {searchTerm?.length > 0 && (
            <div className="search-box-dd">
              {searchResult &&
                searchResult?.map((result) => (
                  <div key={result.url}>
                    <Link
                      to={result.url}
                      onClick={() => {
                        setSearchResult("");
                        setSearchTerm("");
                      }}
                    >
                      {" "}
                      {result.name}
                    </Link>
                    <hr className="m-0" />
                  </div>
                ))}
            </div>
          )}
        </div> */}

        <nav className="header-nav ms-auto-s">
          <ul className="d-flex align-items-center">
            <li className="nav-item d-block d-lg-none search_none">
              <Link className="nav-link nav-icon search-bar-toggle " href="#">
                <i className="bi bi-search">
                  {" "}
                  <img className="img-fluid" src={Search} alt="" />
                </i>
              </Link>
            </li>

            {/* <li
              className="nav-item dropdown mx-4"
              onClick={(e) => {
                setVisible(!visible);
              }}
            >
              <Link
                className="nav-link nav-icon"
                href="#"
                data-bs-toggle="dropdown"
              >
                <i className="bi bi-bell bell-count-parent ">
                  <img className="img-fluid" src={Notid} alt="" />

                  <div className="bell-count">
                    <span>{count}</span>
                  </div>
                </i>
              </Link>

              {visible && (
                <div className="notifction-dropdown">
                  <h3>{t("notifications")} </h3>
                  <Tabs
                    defaultActiveKey="school"
                    onSelect={(k, e) => {
                      e.stopPropagation();
                      setType(k);
                    }}
                    activeKey={type}
                    className="notification-tabs"
                  >
                    <Tab
                      eventKey="school"
                      title="School"
                      className="notifi-wrapper"
                    >
                 

                      {notilist &&
                        notilist?.map((val, i) => (
                          <div className="student-noti">
                            <div className="img-studdnt">
                              <img
                                src={handleimageUrl(val?.sender?.profilePic)}
                              />
                            </div>
                            <div>
                              <h5>{val?.sender?.name}</h5>
                              <p>{val?.message}</p>
                              <span>
                                {moment(val?.createdAt).format("DD-MM-YYYY")}
                              </span>
                            </div>
                          </div>
                        ))}
                    </Tab>

                    <Tab
                      eventKey="transportation"
                      title="Transportation"
                      className="notifi-wrapper"
                    >
                      {notilist &&
                        notilist?.map((val, i) => (
                          <div className="student-noti">
                            <div className="img-studdnt">
                              <img
                                src={handleimageUrl(val?.sender?.profilePic)}
                              />
                            </div>
                            <div>
                              <h5>{val?.sender?.name}</h5>
                              <p>{val?.message}</p>

                          
                              <span>
                                {moment(val?.createdAt).format("DD-MM-YYYY")}
                              </span>
                            </div>
                          </div>
                        ))}
                    </Tab>
                  </Tabs>

                  <div>
                    <center>
                      <Link className="text-lgt-btn" to={`/notificationList`}>
                        {t("view_all")}
                      </Link>
                    </center>
                  </div>

                
                </div>
              )}
            </li> */}
          </ul>
        </nav>
      </header>

      {/* <VisitRequest
        show={NotifyAuthority}
        onHide={() => setNotifyAuthority(false)}
      /> */}
    </div>
  );
}

export default Header;
